<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.NEW_LEGAL_REFERENCE
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>
    <!-- eslint-disable vue/no-v-html -->
    <h4
      class="is-size-7 has-text-centered has-text-weight-semibold has-text-color-7 p-20"
      v-html="General.TEXTS.DESCRIPTION_LEGAL_REFERENCE_MODAL"
    />

    <div class="px-30">
      <b-field class="column is-12" :label="General.LEGAL_REFERENCE">
        <b-input
          v-model="name"
          :placeholder="General.PLACEHOLDER.WRITE_LEGAL_REFERENCE"
        />
      </b-field>
    </div>

    <footer class="modal-card-foot is-align-self-flex-end">
      <div class="buttons">
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          @click="confirmAction"
        >
          {{ General.INCLUDE }}
        </b-button>
        <b-button
          outlined
          :type="isContrast ? 'is-white' : 'is-orange'"
          @click="close"
        >
          {{ General.CANCEL }}
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import { General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "ModalCreateLegalReferenceModa",
  props: {
    create: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      General,
      name: ""
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },

  methods: {
    close() {
      this.$parent.close();
    },
    confirmAction() {
      this.create(this.name);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  background-color: $color-1;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}
</style>
